import * as React from 'react'

import { TextProps } from 'components/common/Text'
import { track } from 'track'
import ExternalLink from 'components/common/ExternalLink'

type TrackedExternalLinkProps = {
  eventName?: 'ExternalLinkClicked' | any
  eventProperties?: {
    [key: string]: any
  }
  href: string
  children: React.ReactNode
} & TextProps

const TrackedExternalLink = React.forwardRef<
  React.Ref<any>,
  TrackedExternalLinkProps
>(
  (
    {
      eventName = 'ExternalLinkClicked',
      eventProperties,
      href,
      ...rest
    }: TrackedExternalLinkProps,
    ref: React.Ref<any>
  ) => {
    return (
      <ExternalLink
        ref={ref}
        href={href}
        onClick={() => {
          track(eventName, { ...eventProperties, link: href })
        }}
        {...rest}
      />
    )
  }
)

export default TrackedExternalLink
